import React from 'react';
import _ from 'lodash';

import RankingMatrixItem from './rankingMatrixItem/rankingMatrixItem';

import { createFilterObject, shuffleArray } from '../../../../util/utils';
import './rankingMatrixIndex.scss';

class RankingMatrixIndex extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(e, answerStatement) {
        const answerValue = +e.target.value;
        const answerPosition = +e.currentTarget.id;

        const promptId = this.props.match.params.promptId;
        const filterObj = createFilterObject(answerValue, promptId, answerPosition, answerStatement);

        this.props.sendReceivedFilterEvent(filterObj);
    }

    shuffle(answerOptions) {
        return shuffleArray(answerOptions, this.props.randomSeed);
    }

    render() {
        const promptId = this.props.match.params.promptId;

        let rows;
        let headers;
        if (this.props.prompt) {
            const prompt = this.props.prompt;
            const answerOptions = prompt.randomize ? this.shuffle(prompt.filters) : prompt.filters;
            const columnDescriptions = prompt.typeOptions.columnDescriptions;
            const colDescCnt = columnDescriptions.filter((el) => el).length;

            rows = answerOptions.map((answerOption, idx) => {
                return (
                    <RankingMatrixItem
                        id={answerOption.id ? answerOption.id - 1 : idx}
                        prompt={prompt}
                        promptId={promptId}
                        answerStatement={answerOption.answerDisplay}
                        handleSelect={this.handleSelect}
                        selectedAnswers={this.props.selectedFilters}
                    />
                )
            })

            headers = columnDescriptions.filter((el) => el).map((description, idx) => {
                return (
                    <div className={colDescCnt -1 === idx ? "header-item-right-text": "header-item"}>{description}</div>
                )
            })
        }

        return (
            <div className="answers-container">
                <div className="description-labels d-t">
                    <div className="header-item placeholder"></div>
                    <div className="header-items">
                        {headers}
                    </div>
                </div>
                {rows}
            </div>
        )
    }

}

export default RankingMatrixIndex;